export const formatConverterSchemaItemList = {
	itemListElement: [
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 1,
			name: 'Image to WEBP',
			url: 'https://liftapp.ai/webp-converter',
			description:
				'Convert images to WEBP format instantly with our online tool. No watermark. Upload photo, select format, and download high-quality WEBP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 2,
			name: 'WEBP to JPEG',
			url: 'https://liftapp.ai/webp-to-jpeg-converter',
			description:
				'Convert WEBP to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 3,
			name: 'WEBP to JPG',
			url: 'https://liftapp.ai/webp-to-jpg-converter',
			description:
				'Convert WEBP to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 4,
			name: 'WEBP to PNG',
			url: 'https://liftapp.ai/webp-to-png-converter',
			description:
				'Convert WEBP to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 5,
			name: 'Image to HEIC',
			url: 'https://liftapp.ai/image-to-heic-converter',
			description:
				'Convert images to HEIC format instantly with our online tool. No watermark. Upload photo, select format, and download high-quality HEIC files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 6,
			name: 'HEIC to JPEG',
			url: 'https://liftapp.ai/heic-to-jpeg-converter',
			description:
				'Convert HEIC to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 7,
			name: 'HEIC to JPG',
			url: 'https://liftapp.ai/heic-to-jpg-converter',
			description:
				'Convert HEIC to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 8,
			name: 'HEIC to PNG',
			url: 'https://liftapp.ai/heic-to-png-converter',
			description:
				'Convert HEIC to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 9,
			name: 'Image to PNG',
			url: 'https://liftapp.ai/png-converter',
			description:
				'Convert images to PNG instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 10,
			name: 'PNG to BMP',
			url: 'https://liftapp.ai/png-to-bmp-converter',
			description:
				'Convert PNG to BMP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality BMP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 11,
			name: 'PNG to JPEG',
			url: 'https://liftapp.ai/png-to-jpeg-converter',
			description:
				'Convert PNG to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 12,
			name: 'PNG to JPG',
			url: 'https://liftapp.ai/png-to-jpg-converter',
			description:
				'Convert PNG to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 13,
			name: 'PNG to WEBP',
			url: 'https://liftapp.ai/png-to-webp-converter',
			description:
				'Convert PNG to WEBP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality WEBP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 14,
			name: 'Image to JPEG',
			url: 'https://liftapp.ai/image-to-jpeg-converter',
			description:
				'Convert Image to JPEG instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 15,
			name: 'JPEG to BMP',
			url: 'https://liftapp.ai/jpeg-to-bmp-converter',
			description:
				'Convert JPEG to BMP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality BMP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 16,
			name: 'JPEG to JPG',
			url: 'https://liftapp.ai/jpeg-to-jpg-converter',
			description:
				'Convert JPEG to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 17,
			name: 'JPEG to PNG',
			url: 'https://liftapp.ai/jpeg-to-png-converter',
			description:
				'Convert JPEG to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 18,
			name: 'JPEG to TIFF',
			url: 'https://liftapp.ai/jpeg-to-tiff-converter',
			description:
				'Convert JPEG to TIFF images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality TIFF files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 19,
			name: 'JPEG to WEBP',
			url: 'https://liftapp.ai/jpeg-to-webp-converter',
			description:
				'Convert JPEG to WEBP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality WEBP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 20,
			name: 'Image to JPG',
			url: 'https://liftapp.ai/image-to-jpg-converter',
			description:
				'Convert Image to JPG instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 21,
			name: 'JPG to BMP',
			url: 'https://liftapp.ai/jpg-to-bmp-converter',
			description:
				'Convert JPG to BMP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality BMP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 22,
			name: 'JPG to JPEG',
			url: 'https://liftapp.ai/jpg-to-jpeg-converter',
			description:
				'Convert JPG to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 23,
			name: 'JPG to PNG',
			url: 'https://liftapp.ai/jpg-to-png-converter',
			description:
				'Convert JPG to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 24,
			name: 'JPG to TIFF',
			url: 'https://liftapp.ai/jpg-to-tiff-converter',
			description:
				'Convert JPG to TIFF images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality TIFF files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 25,
			name: 'JPG to WEBP',
			url: 'https://liftapp.ai/jpg-to-webp-converter',
			description:
				'Convert JPG to WEBP images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality WEBP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 26,
			name: 'Image to TIFF',
			url: 'https://liftapp.ai/image-to-tiff-converter',
			description:
				'Convert images to TIFF format instantly with our online tool. No watermark. Upload photo, select format, and download high-quality TIFF files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 27,
			name: 'TIFF to JPEG',
			url: 'https://liftapp.ai/tiff-to-jpeg-converter',
			description:
				'Convert TIFF to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 28,
			name: 'TIFF to JPG',
			url: 'https://liftapp.ai/tiff-to-jpg-converter',
			description:
				'Convert TIFF to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 29,
			name: 'TIFF to PNG',
			url: 'https://liftapp.ai/tiff-to-png-converter',
			description:
				'Convert TIFF to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 30,
			name: 'Image to BMP',
			url: 'https://liftapp.ai/image-to-bmp-converter',
			description:
				'Convert images to BMP format instantly with our online tool. No watermark. Upload photo, select format, and download high-quality BMP files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 31,
			name: 'BMP to JPEG',
			url: 'https://liftapp.ai/bmp-to-jpeg-converter',
			description:
				'Convert BMP to JPEG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPEG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 32,
			name: 'BMP to JPG',
			url: 'https://liftapp.ai/bmp-to-jpg-converter',
			description:
				'Convert BMP to JPG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality JPG files in seconds. Try now!',
		},
		{
			'@type': 'SoftwareApplication',
			operatingSystem: 'Web',
			applicationCategory: 'MultimediaApplication',
			position: 33,
			name: 'BMP to PNG',
			url: 'https://liftapp.ai/bmp-to-png-converter',
			description:
				'Convert BMP to PNG images instantly with our online tool. No watermark. Upload photo, select format, and download high-quality PNG files in seconds. Try now!',
		},
	],
};
